import { BasicServiceForm } from "./BasicServiceForm";
import { useService } from "./useServiceForm";
import { useValidation } from "./useValidation";
import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { BookingDurationForm } from "./BookingDurationForm";
import { PricingForm } from "./PricingForm";
import primaryComponents from "../../../primaryComponents";
import { PricingWarning, RoutedModal, WarningDialog } from "../../../common";
import { ServiceImageUpload } from "./ServiceImageUpload";
import { MarketPlaceCreation } from "../../SingleProductForm/MarketPlaceCreation";

export const ServiceForm = ({ isEditMode = false, productDetails = {} }) => {
  const formData = useService({ isEditMode, productDetails });
  const { handleSubmit, ...rest } = useValidation({
    ...formData?.rootFormDetails,
  });
  const {
    detectedPricing,
    modalViews,
    isLoadingService,
    resetModalViews,
    handleCreateOrUpdateService,
  } = formData;

  return (
    <>
      <form
        className={`mt-4 ${globalStyles.cardWithBorder}`}
        style={{ gap: "20px" }}
        onSubmit={handleSubmit(handleCreateOrUpdateService)}
      >
        <div className={styles.topSection}>
          <div className={styles.topSection__left}>
            <BasicServiceForm formData={formData} validation={rest} />
          </div>

          <div className="mx-auto">
            <ServiceImageUpload formData={formData} validation={rest} />
          </div>
        </div>

        {formData?.rootFormDetails?.setup_duration ? (
          <BookingDurationForm formData={formData} validation={rest} />
        ) : null}

        <PricingForm
          formData={formData}
          validation={rest}
          isEditMode={isEditMode}
        />

        <MarketPlaceCreation
          isEditMode={isEditMode}
          rootFormDetails={formData?.rootFormDetails}
          setRootFormDetails={formData?.setRootFormDetails}
        />

        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto w-100"}
          style={{ maxWidth: "300px" }}
          isLoading={isLoadingService}
          isDisabled={isLoadingService}
        >
          {isEditMode ? "Update Service" : "Create Service"}
        </primaryComponents.Button>
      </form>

      <RoutedModal
        isActive={modalViews?.isWarning}
        closeModal={() => resetModalViews("isWarning", false)}
        width={500}
        headerTitle="Pricing Warning"
        style={{ height: "auto" }}
      >
        <WarningDialog
          closeModal={() => resetModalViews("isWarning", false)}
          handler={handleCreateOrUpdateService}
        >
          <PricingWarning detectedPricing={detectedPricing} />
        </WarningDialog>
      </RoutedModal>
    </>
  );
};
